import React, {
  useState,
  useEffect,
  useContext,
  useCallback,
  useMemo,
  useRef,
} from "react";
import axios from "axios";
import { useNavigate, useLocation, useParams } from "react-router-dom"; // For navigation and accessing the URL

import { UserContext } from "../context/UserContext";
import {
  Container,
  Typography,
  List,
  ListItem,
  ListItemText,
  ListItemIcon,
  Button,
  CircularProgress,
  Box,
  FormControl,
  Input,
  InputLabel,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  ListItemButton,
  Divider,
  IconButton,
  Grid,
  ListItemSecondaryAction,
  ListItemAvatar,
  Avatar,
  Card,
  Paper,
  TextField,
  ToggleButton,
  ToggleButtonGroup,
  Autocomplete,
} from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { Checkbox, FormControlLabel } from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import DescriptionIcon from "@mui/icons-material/Description";
import CloseIcon from "@mui/icons-material/Close";
import Alert from "@mui/material/Alert";
import CreateNewFolderIcon from "@mui/icons-material/CreateNewFolder"; // Import CreateNewFolderIcon
import {
  AttachFile,
  Download,
  Folder,
  PersonAdd,
  Search,
  Backspace,
  Email,
  PendingActions,
  CheckCircle,
  Cancel,
  CheckBoxOutlineBlank,
  CheckBox,
} from "@mui/icons-material";
import { Badge, Chip } from "@mui/material";
import firebase from "../firebase";
// import { auth, sendPasswordResetEmail, signOut } from "../firebase";
import auth from "../firebase";
import sendPasswordResetEmail from "../firebase";
import signOut from "../firebase";
import { debounce } from "lodash"; // Import debounce function
import ActionMenuButton from "./ActionMenuButton";
import FileTree from "./FileTree";
import moment from "moment";
import { apiLink } from "../common";
import { useDropzone } from "react-dropzone";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";

const stripHtml = (value = "") =>
  value
    .replace(/<[^>]*>/g, " ")
    .replace(/&nbsp;/g, " ")
    .trim();

function Dashboard() {
  const [manageInvestor, setManageInvestor] = useState(false);
  const { user, setUser } = useContext(UserContext);
  const [currentFolderId, setCurrentFolderId] = useState("");
  const [genericFolderId, setGenericFolderId] = useState(false);
  const [downloadingFileID, setDownloadingFileID] = useState(-1);
  const [breadCrumbs, setbreadCrumbs] = useState([]);
  const isNavigatingRef = useRef(false);
  const [folders, setFolders] = useState([]);
  const [files, setFiles] = useState([]);
  const [error, setError] = useState(null);
  const [uploading, setUploading] = useState(false);
  const [assignUserLoading, setAssignUserLoading] = useState(false);
  // const [selectedFile, setSelectedFile] = useState([]);
  const [newFolderEmail, setNewFolderEmail] = useState(null);
  const [newFolderPhone, setNewFolderPhone] = useState(null);
  const [loadingClientFolders, setLoadingClientFolders] = useState(true);
  const [loadingGenericFolders, setLoadingGenericFolders] = useState(true);
  const [loading, setLoading] = useState(true);
  const [showSearch, setShowSearch] = useState(false);
  const [searchText, setSearchText] = useState("");
  const [showingOptions, setShowingOptions] = useState(null);
  const [debouncedSearchText, setDebouncedSearchText] = useState("");
  const [genericFolderData, setGenericFolderData] = useState([]);
  const [selectedFiles, setSelectedFiles] = useState([]);
  const [sendEmailDialogOpen, setSendEmailDialogOpen] = useState(false);
  const [sendEmailMode, setSendEmailMode] = useState("all");
  const [selectedEmailRecipients, setSelectedEmailRecipients] = useState([]);
  const [emailSubject, setEmailSubject] = useState("");
  const [emailMessage, setEmailMessage] = useState("");
  const [sendEmailError, setSendEmailError] = useState(null);
  const [sendEmailSuccess, setSendEmailSuccess] = useState(null);
  const [sendingEmail, setSendingEmail] = useState(false);
  const [pendingCount, setPendingCount] = useState(0);
  const navigate = useNavigate(); //
  const location = useLocation(); // Get the current location
  const { folderId: urlFolderId } = useParams();
  const theme = useTheme();
  const MySwal = useMemo(() => withReactContent(Swal), []);

  const currentPath = useMemo(() => {
    if (breadCrumbs.length > 0) {
      return breadCrumbs.map((b) => b.name).join("/");
    }

    if (currentFolderId) {
      let folderName = "";
      const folder =
        folders.find((f) => String(f.id) === String(currentFolderId)) ||
        genericFolderData.find((f) => String(f.id) === String(currentFolderId));
      if (folder) folderName = folder.name;

      const filesWithPaths = files.filter((f) => f.filePath);
      if (filesWithPaths.length > 0) {
        const paths = filesWithPaths.map((f) =>
          (f.filePath || "").replace(/\\/g, "/").split("/")
        );

        let common = paths[0];
        // Remove last element (filename) from the first path to start with directory
        // Wait, split includes filename. We only want directory prefix.
        // But common prefix logic will handle it if multiple files.
        // If single file, common includes filename.

        if (paths.length === 1) {
          common.pop(); // Remove filename
        } else {
          for (let i = 1; i < paths.length; i++) {
            const p = paths[i];
            let j = 0;
            while (j < common.length && j < p.length && common[j] === p[j]) j++;
            common = common.slice(0, j);
          }
        }

        if (folderName) {
          const idx = common.indexOf(folderName);
          if (idx !== -1) {
            return common.slice(0, idx + 1).join("/");
          }
          return folderName;
        }
        return common.join("/");
      }
      return folderName;
    }
    return "";
  }, [breadCrumbs, currentFolderId, folders, genericFolderData, files]);

  const showInvestorUploadAlert = useCallback(() => {
    MySwal.fire({
      icon: "info",
      title: "Submission received",
      text: "Thanks for uploading your files. They have been submitted and are now under review. We'll notify you once they're approved.",
      showConfirmButton: true,
      confirmButtonText: "Close",
      confirmButtonColor: theme.palette.primary.main,
      focusConfirm: false,
      allowOutsideClick: false,
      backdrop: false,
      customClass: {
        popup: "investor-upload-alert",
      },
      didOpen: (popup) => {
        popup.style.boxShadow = "0 16px 40px rgba(0,0,0,0.2)";
        popup.style.borderRadius = "16px";
        popup.style.zIndex = "2001";
        const container = popup.parentElement;
        if (container) {
          container.style.zIndex = "2000";
          container.style.pointerEvents = "none";
        }
        popup.style.pointerEvents = "auto";
      },
      willClose: () => MySwal.close(),
    });
  }, [MySwal, theme]);

  const debouncedSearch = debounce(() => {
    setDebouncedSearchText(searchText);
  }, 1000);

  useEffect(() => {
    debouncedSearch();
  }, [searchText, debouncedSearch]);

  const handleClearSearch = () => {
    setSearchText("");
    setDebouncedSearchText("");
  };

  const getFiles = useCallback(
    async (folderId = null) => {
      const targetFolderId = folderId || currentFolderId;
      if (!user || !targetFolderId) return;

      // Double-check we're not navigating
      if (isNavigatingRef.current && !folderId) {
        console.log("getFiles: Skipping - navigation in progress");
        return;
      }

      try {
        setLoading(true);
        console.log("getFiles: Fetching files for folder:", targetFolderId);
        const response = await axios.get(
          `${apiLink}/api/files/folder/${targetFolderId}`,
          {
            headers: {
              Authorization: `Bearer ${user.token}`,
            },
          }
        );
        let filesData = response.data || [];
        console.log(
          "getFiles: Raw API response for folder",
          targetFolderId,
          ":",
          filesData
        );

        // Filter out the current folder from the list (shouldn't appear as its own child)
        const beforeFilter = filesData.length;
        filesData = filesData.filter((item) => {
          const itemId = String(item.id);
          const folderId = String(targetFolderId);
          const shouldKeep = itemId !== folderId;
          if (!shouldKeep) {
            console.log(
              "getFiles: Filtering out folder/item with ID:",
              itemId,
              "because it matches current folder:",
              folderId
            );
          }
          return shouldKeep;
        });
        console.log(
          "getFiles: Filtered",
          beforeFilter - filesData.length,
          "items. Remaining:",
          filesData.length
        );

        // Filter out rejected files for everyone
        filesData = filesData.filter((item) => {
          // Keep folders (no filePath means it's a folder)
          if (!item.filePath) return true;

          // Hide rejected files
          if (item.status === "rejected") return false;

          // For non-admin users, filter out files under review
          if (user?.role !== "A") {
            // For files, only show if status is "approved" or undefined/null (treated as approved)
            return !item.status || item.status === "approved";
          }

          return true;
        });

        // Only update if we're still on the same folder
        if (String(targetFolderId) === String(currentFolderId)) {
          setFiles(filesData);
          console.log(
            "getFiles: Loaded",
            filesData.length,
            "items for folder",
            targetFolderId
          );
        } else {
          console.log(
            "getFiles: Skipping update - folder changed from",
            targetFolderId,
            "to",
            currentFolderId
          );
        }
        setLoading(false);
      } catch (error) {
        setLoading(false);
        console.log("get files error", error);
        if (error.response?.status !== 404) {
          setError(error.message);
        } else {
          // 404 means folder is empty, set empty array
          if (String(targetFolderId) === String(currentFolderId)) {
            setFiles([]);
          }
        }
      }
    },
    [user, currentFolderId, apiLink]
  );

  const getGenericFolders = async (showLoading) => {
    if (!user) return;
    try {
      if (showLoading) setLoadingGenericFolders(true);
      const response = await axios.get(
        apiLink + "/api/folders/admin-folder/" + user?.id,
        {
          headers: {
            Authorization: `Bearer ${user.token}`,
          },
          // params: {
          //   searchText: debouncedSearchText, // Use debouncedSearchText in the request
          // },
        }
      );

      // console.log(response?.data,"folders");
      await setGenericFolderData(response?.data?.folders);
      // if (user?.role !== "A")
      //   setCurrentFolder(response.data[0].id, response.data[0].name);
      setLoadingGenericFolders(false);
    } catch (error) {
      // if (error.response.status == 401) handleLogout();
      setLoadingGenericFolders(false);
      setError(error.message);
    }
  };

  const getGenericFoldersForUser = async (showLoading) => {
    if (!user) return;
    try {
      if (showLoading) setLoadingGenericFolders(true);
      const response = await axios.get(
        apiLink + "/api/folders/client-folder/" + user?.id,
        {
          headers: {
            Authorization: `Bearer ${user.token}`,
          },
          // params: {
          //   searchText: debouncedSearchText, // Use debouncedSearchText in the request
          // },
        }
      );

      console.log(response?.data, "folders");
      console.log(response?.data, "response?.data");

      await setGenericFolderData(response?.data?.folders);
      // if (user?.role !== "A")
      //   setCurrentFolder(response.data[0].id, response.data[0].name);
      setLoadingGenericFolders(false);
    } catch (error) {
      // if (error.response.status == 401) handleLogout();
      setLoadingGenericFolders(false);
      setError(error.message);
    }
  };

  const getFolders = async (showLoading) => {
    if (!user) return;
    try {
      if (showLoading) setLoadingClientFolders(true);
      const response = await axios.get(apiLink + "/api/folders", {
        headers: {
          Authorization: `Bearer ${user.token}`,
        },
        params: {
          searchText: debouncedSearchText, // Use debouncedSearchText in the request
        },
      });

      // console.log(response?.data?.clientId, "folders");
      await setFolders(response.data);
      // Auto-redirect logic moved to a separate useEffect
      setLoadingClientFolders(false);
    } catch (error) {
      // if (error.response.status == 401) handleLogout();
      setLoadingClientFolders(false);
      setError(error.message);
    }
  };

  useEffect(() => {
    if (user?.role === "A") {
      getGenericFolders();
    } else {
      getGenericFoldersForUser();
    }
  }, [user]);

  useEffect(() => {
    console.log("user");
    getFolders();
    console.log(folders, "fodlderdASHBOARD");
  }, [user, debouncedSearchText]);

  const myClientFolders = useMemo(() => {
    if (!user || user.role === "A") return [];
    return folders.filter((data) => Number(data.clientId) === user.id);
  }, [folders, user]);

  // Auto-redirect for investors
  useEffect(() => {
    if (
      !user ||
      user.role === "A" ||
      loadingClientFolders ||
      loadingGenericFolders ||
      currentFolderId
    )
      return;

    // Combine direct folders and assigned folders
    const availableFolders = [...myClientFolders, ...genericFolderData];

    // Filter out duplicates just in case
    const uniqueFolders = availableFolders.filter(
      (folder, index, self) =>
        index === self.findIndex((f) => f.id === folder.id)
    );

    if (uniqueFolders.length === 1) {
      console.log(
        "Auto-redirecting to single available folder:",
        uniqueFolders[0]
      );
      setCurrentFolder(uniqueFolders[0].id, uniqueFolders[0].name);
    }
  }, [
    user,
    loadingClientFolders,
    loadingGenericFolders,
    currentFolderId,
    myClientFolders,
    genericFolderData,
  ]);

  useEffect(() => {
    // Skip if we're manually navigating (setCurrentFolder handles it)
    if (isNavigatingRef.current) {
      console.log(
        "useEffect: Skipping getFiles() - manual navigation in progress"
      );
      return;
    }
    if (currentFolderId) {
      console.log(
        "useEffect: Will call getFiles() for folder:",
        currentFolderId
      );
      // Use a timeout to ensure state is settled and navigation is complete
      const timeoutId = setTimeout(() => {
        // Double-check we're still not navigating and folderId hasn't changed
        if (!isNavigatingRef.current && currentFolderId) {
          console.log(
            "useEffect: Calling getFiles() for folder:",
            currentFolderId
          );
          getFiles();
        } else {
          console.log(
            "useEffect: Skipped getFiles() - navigation in progress or folderId changed"
          );
        }
      }, 1000); // Increased to 1000ms to ensure setCurrentFolder completes first
      return () => clearTimeout(timeoutId);
    } else {
      // No folder selected, clear files
      setFiles([]);
    }
  }, [currentFolderId, user, getFiles]);

  // Fetch pending reviews count (all users can see their own pending files)
  const fetchPendingReviews = useCallback(async () => {
    if (!user) return;

    try {
      const response = await axios.get(`${apiLink}/api/files/pending`, {
        headers: {
          Authorization: `Bearer ${user.token}`,
        },
      });
      const files = Array.isArray(response.data)
        ? response.data
        : response.data?.files || [];
      setPendingCount(files.length || 0);
    } catch (error) {
      console.error("Error fetching pending count:", error);
      setPendingCount(0);
    }
  }, [user, apiLink]);

  useEffect(() => {
    if (user) {
      fetchPendingReviews();
    } else {
      setPendingCount(0);
    }
  }, [user, fetchPendingReviews]);

  // console.log(genericFolderData, "setGenericFolderData");

  const [dragActive, setDragActive] = useState(false); // Example of another useState

  const [openAddFileDialog, setOpenAddFileDialog] = useState(false);
  const [openCreateFolderDialog, setOpenCreateFolderDialog] = useState(false);

  const handleAddFileDialogOpen = () => {
    setOpenAddFileDialog(true);
  };

  useEffect(() => {
    console.log(selectedFiles, "emptyselectedfile");
  }, [selectedFiles]);

  const handleAddFileDialogClose = () => {
    setSelectedFiles([]);
    setOpenAddFileDialog(false);
  };

  const handleCreateFolderDialogClose = () => {
    setOpenCreateFolderDialog(false);
    setGenericFolderId(false);
  };

  const handleOpenSendEmailDialog = () => {
    setSendEmailDialogOpen(true);
    setSendEmailMode("selected");
    setSelectedEmailRecipients(folders || []);
  };

  const handleCloseSendEmailDialog = () => {
    setSendEmailDialogOpen(false);
    setSendEmailMode("selected");
    setSelectedEmailRecipients([]);
    setEmailSubject("");
    setEmailMessage("");
    setSendEmailError(null);
    setSendEmailSuccess(null);
    setSendingEmail(false);
  };

  const handleSendEmailModeChange = (event, newValue) => {
    if (newValue !== null) {
      setSendEmailMode(newValue);
    }
  };

  const handleSelectedRecipientsChange = (event, newValue) => {
    setSelectedEmailRecipients(newValue ?? []);
  };

  const quillModules = useMemo(
    () => ({
      toolbar: [
        [{ header: [1, 2, 3, false] }],
        ["bold", "italic", "underline", "strike"],
        [{ list: "ordered" }, { list: "bullet" }],
        ["link"],
        ["clean"],
      ],
    }),
    []
  );

  const quillFormats = useMemo(
    () => [
      "header",
      "bold",
      "italic",
      "underline",
      "strike",
      "list",
      "bullet",
      "link",
    ],
    []
  );

  const isEmailBodyEmpty = useMemo(
    () => stripHtml(emailMessage).length === 0,
    [emailMessage]
  );

  const handleSendEmail = async () => {
    if (sendingEmail) return;

    if (!emailSubject.trim()) {
      setSendEmailError("Subject is required.");
      setSendEmailSuccess(null);
      return;
    }

    const availableFolders = folders || [];
    const recipientFolders =
      sendEmailMode === "all" ? availableFolders : selectedEmailRecipients;

    if (!recipientFolders.length) {
      setSendEmailError("Please select at least one investor.");
      setSendEmailSuccess(null);
      return;
    }

    const folderIds = recipientFolders
      .map((folder) => Number(folder?.id))
      .filter((id) => !Number.isNaN(id));

    if (!folderIds.length) {
      setSendEmailError("Unable to determine selected investors.");
      setSendEmailSuccess(null);
      return;
    }

    if (isEmailBodyEmpty) {
      setSendEmailError("Message cannot be empty.");
      setSendEmailSuccess(null);
      return;
    }

    try {
      setSendingEmail(true);
      setSendEmailError(null);
      setSendEmailSuccess(null);

      await axios.post(
        `${apiLink}/api/folders/send-email`,
        {
          folderIds,
          subject: emailSubject.trim(),
          message: emailMessage.trim(),
        },
        {
          headers: {
            Authorization: `Bearer ${user.token}`,
          },
        }
      );

      setSendEmailSuccess("Emails sent successfully.");
      setTimeout(() => {
        handleCloseSendEmailDialog();
      }, 1000);
    } catch (error) {
      const message =
        error?.response?.data?.error ||
        error?.message ||
        "Failed to send emails.";
      setSendEmailError(message);
    } finally {
      setSendingEmail(false);
    }
  };

  const [newFolderName, setNewFolderName] = useState("");
  const [creatingFolder, setCreatingFolder] = useState(false);

  const handleFolderNameChange = (e) => {
    setNewFolderName(e.target.value);
  };

  const handleNewFolderEmailChange = (e) => {
    console.log(e.target.value, "aaaaaaaaaaaa");

    setNewFolderEmail(e.target.value);
  };
  const handleNewFolderPhoneChange = (e) => {
    setNewFolderPhone(e.target.value);
  };

  const setCurrentFolder = async (id, name) => {
    const folderIdStr = String(id);
    const currentIdStr = String(currentFolderId || "");

    console.log("setCurrentFolder called:", {
      id,
      name,
      folderIdStr,
      currentIdStr,
      isNavigating: isNavigatingRef.current,
    });

    // Prevent adding the same folder to breadcrumbs if already in it
    if (folderIdStr === currentIdStr && currentIdStr !== "") {
      console.log("Already in folder:", folderIdStr, "- skipping navigation");
      return;
    }

    // Prevent double-click/double-call
    if (isNavigatingRef.current) {
      console.log("Navigation already in progress - skipping");
      return;
    }

    console.log("Proceeding with navigation to folder:", folderIdStr);

    // Mark that we're manually navigating
    isNavigatingRef.current = true;

    // Clear files immediately to prevent showing stale data
    setFiles([]);

    // Update breadcrumbs - only add if not already the last item
    const lastCrumb = breadCrumbs[breadCrumbs.length - 1];
    const tempBreadcrumbs =
      lastCrumb && String(lastCrumb.id) === folderIdStr
        ? breadCrumbs
        : [...breadCrumbs, { id, name }];
    setbreadCrumbs(tempBreadcrumbs);

    // Set folderId immediately BEFORE navigation
    setCurrentFolderId(folderIdStr);

    // Navigate to update URL
    navigate(`/folder/${id}`);
    console.log("Navigation triggered to:", `/folder/${id}`);

    // Immediately fetch files for the new folder
    if (user) {
      try {
        console.log("Fetching files for folder:", folderIdStr);
        const response = await axios.get(
          `${apiLink}/api/files/folder/${folderIdStr}`,
          {
            headers: {
              Authorization: `Bearer ${user.token}`,
            },
          }
        );
        let filesData = response.data || [];
        console.log("Raw API response for folder", folderIdStr, ":", filesData);

        // Filter out the current folder from the list (shouldn't appear as its own child)
        const beforeFilter = filesData.length;
        filesData = filesData.filter((item) => {
          const itemId = String(item.id);
          const folderId = String(folderIdStr);
          const shouldKeep = itemId !== folderId;
          if (!shouldKeep) {
            console.log(
              "Filtering out folder/item with ID:",
              itemId,
              "because it matches current folder:",
              folderId
            );
          }
          return shouldKeep;
        });
        console.log(
          "Filtered",
          beforeFilter - filesData.length,
          "items. Remaining:",
          filesData.length
        );

        // Filter out rejected files for everyone
        filesData = filesData.filter((item) => {
          if (!item.filePath) return true;
          if (item.status === "rejected") return false;

          if (user?.role !== "A") {
            return !item.status || item.status === "approved";
          }
          return true;
        });

        // Set files directly - we already set currentFolderId above
        // Use setTimeout to ensure state has settled
        setTimeout(() => {
          setFiles(filesData);
          console.log(
            "Files loaded for folder:",
            folderIdStr,
            "Count:",
            filesData.length,
            "Files:",
            filesData
          );
        }, 100);

        // Reset navigation flag after a delay to prevent useEffect from running
        setTimeout(() => {
          isNavigatingRef.current = false;
          console.log("Navigation flag reset for folder:", folderIdStr);
        }, 800);
      } catch (error) {
        console.log("get files error", error);
        isNavigatingRef.current = false;
        if (error.response?.status === 404) {
          // 404 means folder is empty or doesn't exist, set empty array
          setFiles([]);
          console.log(
            "Folder is empty or not found, setting empty files array"
          );
        } else {
          setError(error.message);
          console.error("Error fetching files:", error);
        }
      }
    } else {
      // No user, reset navigation flag
      isNavigatingRef.current = false;
    }
  };

  const goBack = () => {
    breadCrumbs.pop();
    setbreadCrumbs(breadCrumbs);
    if (breadCrumbs.length > 0) {
      setCurrentFolderId(breadCrumbs[breadCrumbs.length - 1].id);
      navigate(`/folder/${breadCrumbs[breadCrumbs.length - 1].id}`);
    } else {
      setCurrentFolderId("");
      navigate(`/`);
    }
  };

  useEffect(() => {
    // Use useParams to get folderId from URL, or extract from pathname as fallback
    const folderId =
      urlFolderId || location.pathname.split("/folder/")[1] || "";
    console.log(
      "URL changed, folderId from URL:",
      folderId,
      "currentFolderId:",
      currentFolderId
    );
    if (folderId) {
      // Always update if folderId exists and is different
      setCurrentFolderId((prevId) => {
        if (prevId !== folderId) {
          console.log("Setting currentFolderId to:", folderId);
          return folderId;
        }
        return prevId;
      });
    } else {
      setCurrentFolderId("");
    }
  }, [urlFolderId, location.pathname]);

  //check if browser back button is clicked
  window.onpopstate = function (e) {
    e.preventDefault();
    if (!currentFolderId) {
      let back = window.confirm("Are you sure you want to go to login page?");
      if (back) {
        goBack();
      }
    } else goBack();
  };

  function isPhoneNumber(input) {
    // Define the regular expression for the phone number pattern
    const phoneNumberPattern = /^(\+?1\s?)?(\d{3}[-\s]?)?\d{3}[-\s]?\d{4}$/;

    if (!phoneNumberPattern.test(input)) {
      return false;
    }

    const digitCount = (input.match(/\d/g) || []).length;
    return digitCount >= 10;
  }

  const createFolder = async () => {
    try {
      if (!currentFolderId) {
        if (!genericFolderId) {
          // Validate email format
          const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
          if (!emailRegex.test(newFolderEmail)) {
            setError("Invalid email format");
            return;
          }

          if (!isPhoneNumber(newFolderPhone)) {
            setError("Invalid phone number");
            return;
          }
        }
      }
      setCreatingFolder(true);
      // const submit={
      //       name: newFolderName,
      //       parentId: currentFolderId,
      //       email: newFolderEmail,
      //       phone: newFolderPhone,
      //       folder_type: genericFolderId ? "1" : "0",
      //     }

      const response = await axios.post(
        apiLink + "/api/folders",
        {
          name: newFolderName,
          parentId: genericFolderId ? "0" : currentFolderId,
          email: newFolderEmail,
          phone: newFolderPhone,
          folder_type: genericFolderId ? "1" : "0",
          // adminId: user?.id,
        },
        {
          headers: {
            Authorization: `Bearer ${user.token}`,
          },
        }
      );
      console.log(newFolderEmail, "newFolderEmail");

      if (!currentFolderId) {
        if (genericFolderId) {
          if (genericFolderData?.length) {
            setGenericFolderData([...genericFolderData, response.data]);
          } else {
            setGenericFolderData([response.data]);
          }
        } else {
          setFolders([...folders, response.data]);
        }
      }
      setNewFolderName("");
      setNewFolderEmail(null);
      setNewFolderPhone(null);
      setOpenAddFileDialog(null);
      setOpenCreateFolderDialog(null);
      setCreatingFolder(false);
      setOpenAddFileDialog(null);
      setOpenCreateFolderDialog(null);
      getFiles();
      setGenericFolderId("");
      getFolders(false);
      setOpenCreateFolderDialog(false);
      if (newFolderEmail) {
        firebase.auth().sendPasswordResetEmail(newFolderEmail);
      }
      // if (!currentFolderId) setFolders([...folders, response.data]);
      // if (newFolderEmail)

      // firebase.auth().sendPasswordResetEmail(newFolderEmail);
      // if (newFolderEmail) sendPasswordResetEmail(auth, newFolderEmail);
      // firebase.auth().sendPasswordResetEmail(newFolderEmail);
    } catch (error) {
      console.error(error);
      console.log(error?.request?.response);
      if (error?.request?.response) alert(error.request.response);
      setCreatingFolder(false);
    }
  };

  const handleAssignUser = async ({ folder_id, user_id }) => {
    setAssignUserLoading(true);
    const response = await axios.post(
      apiLink + "/api/folders/assign-folder",
      {
        userId: user_id,
        folderId: folder_id,
      },
      {
        headers: {
          Authorization: `Bearer ${user.token}`,
        },
      }
    );
    console.log(response.data, "rrrrrrrrrrrrrrrrrrrr");

    if (response) {
      setAssignUserLoading(false);
    }

    // if (!currentFolderId) setFolders([...folders, response.data]);
  };

  const rename = async ({
    id,
    type = "folders",
    oldName,
    newName,
    newEmail,
    newPhone,
    generic,
  }) => {
    try {
      let indexToChange = -1;

      if (generic === "true") {
        indexToChange = genericFolderData.findIndex((file) => file.id === id);

        if (indexToChange !== -1) {
          genericFolderData[indexToChange].name = newName;
          setGenericFolderData([...genericFolderData]);
        }
      } else if (newEmail) {
        indexToChange = folders.findIndex((file) => file.id == id);

        if (indexToChange !== -1) {
          folders[indexToChange].name = newName;
          setFolders([...folders]);
        }
      } else {
        if (type == "files") {
          const lastDotIndex = oldName.lastIndexOf(".");
          const fileExtension = oldName.substring(lastDotIndex + 1);
          newName = `${newName}.${fileExtension}`;
        }
        indexToChange = files.findIndex((file) => file.id == id);
        if (indexToChange !== -1) {
          files[indexToChange].name = newName;
          setFiles([...files]);
        }
      }

      const response = await axios.put(
        `${apiLink}/api/${type}`,
        {
          name: newName,
          email: newEmail,
          phone: newPhone,
          id,
        },
        {
          headers: {
            Authorization: `Bearer ${user.token}`,
          },
        }
      );

      // if (type == 'folders') getFolders();
      // else getFiles();
    } catch (error) {
      console.error(error);
      if (error?.request?.response) alert(error.request.response);
    }
  };

  const deleteItem = async ({ id, email, type = "folders", generic }) => {
    try {
      let indexToChange = -1;
      if (generic === "true") {
        indexToChange = genericFolderData.findIndex((file) => file.id == id);
        if (indexToChange !== -1)
          setGenericFolderData([
            ...genericFolderData.slice(0, indexToChange),
            ...genericFolderData.slice(indexToChange + 1),
          ]);
      } else if (email) {
        indexToChange = folders.findIndex((file) => file.id == id);
        if (indexToChange !== -1)
          setFolders([
            ...folders.slice(0, indexToChange),
            ...folders.slice(indexToChange + 1),
          ]);
      } else {
        indexToChange = files.findIndex((file) => file.id == id);
        if (indexToChange !== -1)
          setFiles([
            ...files.slice(0, indexToChange),
            ...files.slice(indexToChange + 1),
          ]);
      }

      const response = await axios.delete(`${apiLink}/api/${type}/${id}`, {
        headers: {
          Authorization: `Bearer ${user.token}`,
        },
      });

      // if (type == 'folders') getFolders();
      // else getFiles();
    } catch (error) {
      console.error(error);
      if (error?.request?.response) alert(error.request.response);
    }
  };

  const moveItem = async ({ id, type = "folders", destinationId, generic }) => {
    try {
      if (!destinationId) {
        alert("Please select a destination folder.");
        return;
      }

      const endpoint =
        type === "files"
          ? `${apiLink}/api/files/move`
          : `${apiLink}/api/folders/move`;

      await axios.put(
        endpoint,
        {
          id,
          parentId: destinationId,
        },
        {
          headers: {
            Authorization: `Bearer ${user.token}`,
          },
        }
      );

      window.location.reload();
      if (type === "files") {
        await getFiles();
      } else if (generic === "true") {
        await getGenericFolders(true);
      } else {
        await getFolders(false);
      }
    } catch (error) {
      setLoading(false);

      console.error(error);
      if (error?.request?.response) alert(error.request.response);
    }
  };
  const downloadFile = async (fileId, name) => {
    try {
      setDownloadingFileID(fileId);
      const response = await axios.get(
        `${apiLink}/api/files/download/${fileId}`,
        {
          headers: {
            Authorization: `Bearer ${user.token}`,
          },
          responseType: "blob", // Set response type to blob
        }
      );

      const filename = name;
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", filename);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      setDownloadingFileID(-1);
    } catch (error) {
      setDownloadingFileID(-1);
      console.error(error);
    }
  };
  const handleLogout = async () => {
    await firebase.auth().signOut();
    await signOut(auth);
    await firebase.auth().signOut();
    localStorage.clear();
    setUser(null);
    // window.location.reload();
  };

  const generateRandomColor = () => {
    let colors = [
      "#005a31", // Dark Green
      "#2F4F4F", // Dark Slate Gray
      "#6A5ACD", // Slate Blue
      "#8B008B", // Dark Magenta
      "#800000", // Maroon
      "#556B2F", // Dark Olive Green
      "#483D8B", // Dark Slate Blue
      "#2E8B57", // Sea Green
      "#3D5A80", // Prussian Blue
      "#696969", // Dim Gray
      "#800020", // Burgundy
      "#FF4500", // Orange Red
      "#7B68EE", // Medium Slate Blue
      "#4682B4", // Steel Blue
      "#008B8B", // Dark Cyan
      "#B22222", // Fire Brick
    ];
    const randomColorKey = colors[Math.floor(Math.random() * colors.length)];
    return randomColorKey;
  };

  const handleDrop = (acceptedFiles) => {
    setSelectedFiles(acceptedFiles);
    console.log(acceptedFiles, "acceptedFiles");
  };
  // console.log(selectedFile,"selectedFile");

  const onUpload = useCallback(async () => {
    if (selectedFiles.length === 0) return; // If no files are selected, do nothing

    try {
      setUploading(true);

      const formData = new FormData();
      const folderStructure = {};

      selectedFiles.forEach((file) => {
        const fullPath = file.path; // This includes the folder path and file name

        // Add file and its path to formData
        formData.append("files", file);
        formData.append("paths", fullPath);

        // Extract the folder path
        const parts = fullPath.split("/");
        parts.pop(); // Remove the file name
        const folderPath = parts.join("/");

        // Store the folder path in the structure
        if (folderPath) {
          if (!folderStructure[folderPath]) {
            folderStructure[folderPath] = true;
          }
        }
      });

      // Send the folder structure along with the files
      formData.append("folderStructure", JSON.stringify(folderStructure));

      const config = {
        headers: {
          "content-type": "multipart/form-data",
          Authorization: `Bearer ${user.token}`,
        },
      };

      await axios.post(
        `${apiLink}/api/files/upload/${currentFolderId}`,
        formData,
        config
      );

      const response = await axios.get(
        `${apiLink}/api/files/folder/${currentFolderId}`,
        { headers: { Authorization: `Bearer ${user.token}` } }
      );

      let filesData = response.data;

      // Filter out rejected files for everyone
      filesData = filesData.filter((item) => {
        // Keep folders (no filePath means it's a folder)
        if (!item.filePath) return true;

        // Hide rejected files
        if (item.status === "rejected") return false;

        // For non-admin users, filter out files under review
        if (user?.role !== "A") {
          // For files, only show if status is "approved" or undefined/null (treated as approved)
          return !item.status || item.status === "approved";
        }

        return true;
      });

      setFiles(filesData);
      setSelectedFiles([]);
      setOpenAddFileDialog(null);
      setOpenCreateFolderDialog(null);
      setUploading(false);
      handleAddFileDialogClose();

      // Refresh pending count so the badge updates immediately
      fetchPendingReviews();

      if (user?.role !== "A") {
        // Ensure the SweetAlert opens after the upload modal fully closes
        setTimeout(() => {
          showInvestorUploadAlert();
        }, 0);
      }
    } catch (error) {
      console.error(error);
    } finally {
      setUploading(false);
    }
  }, [
    selectedFiles,
    apiLink,
    currentFolderId,
    handleAddFileDialogClose,
    user,
    MySwal,
    showInvestorUploadAlert,
    fetchPendingReviews,
  ]);

  const { getRootProps, getInputProps, open, isDragActive } = useDropzone({
    onDrop: handleDrop,
    noClick: true, // Disables the click to open file dialog
    noKeyboard: true, // Disables the keyboard behavior
    webkitdirectory: true, // Enable folder uploads
    directory: true,
    multiple: true, // Allow multiple files and folders
    onDragEnter: () => setDragActive(true),
    onDragLeave: () => setDragActive(false),
    accept: "image/*,application/pdf",
  });
  // useEffect(()=>{
  const existFile = [...genericFolderData, ...files];
  // },[genericFolderData,files])
  console.log(genericFolderData, "genericFolderData");

  return (
    <Container
      maxWidth="md"
      sx={{
        "&.MuiContainer-root": { paddingLeft: 0 },
        root: { paddingLeft: 0 },
        paddingLeft: { xs: 0 },
        paddingRight: { xs: 0 },
      }}
    >
      {(loadingClientFolders || loadingGenericFolders) && !showSearch ? (
        <Grid
          container
          direction={"column"}
          justifyContent={"center"}
          alignItems={"center"}
        >
          <Grid item>
            <CircularProgress />
          </Grid>
          <Grid item>
            <Typography>Loading Folders & Files ...</Typography>
          </Grid>
        </Grid>
      ) : !currentFolderId ? (
        <>
          {/* <Typography variant='h6' component='h2' align='left' gutterBottom>
            Folders
          </Typography> */}
          {/* Search Bar - Show for all users */}
          <Grid container justifyContent={"start"} sx={{ mb: 2 }}>
            <Grid item xs={12} marginLeft={2}>
              {showSearch ? (
                <Grid
                  container
                  alignItems={"end"}
                  justifyContent={"end"}
                ></Grid>
              ) : (
                <Grid
                  container
                  justifyContent={"end"}
                  spacing={2}
                  alignItems="center"
                >
                  {user?.role === "A" && !manageInvestor && (
                    <>
                      <Grid item>
                        <Button
                          onClick={() => setManageInvestor(true)}
                          style={{ color: "white" }}
                          variant="contained"
                          startIcon={<PersonAdd />}
                        >
                          Manage Investors
                        </Button>
                      </Grid>
                      <Grid item>
                        <Button
                          onClick={handleOpenSendEmailDialog}
                          variant="outlined"
                          color="primary"
                          startIcon={<Email />}
                        >
                          Send Email
                        </Button>
                      </Grid>
                    </>
                  )}
                  {/* Pending Reviews button - Show for ALL users */}
                  <Grid item>
                    <Badge badgeContent={pendingCount} color="error">
                      <Button
                        onClick={() => navigate("/pending-reviews")}
                        variant="outlined"
                        color="primary"
                        startIcon={<PendingActions />}
                      >
                        Pending Reviews
                      </Button>
                    </Badge>
                  </Grid>
                </Grid>
              )}
            </Grid>
          </Grid>
          {user?.role === "A" && (
            <>
              {/* <ListItemButton
                color='primary'
                button
                onClick={() => setOpenCreateFolderDialog(true)}
                style={{ display: 'flex', alignItems: 'center' }}
              >
                <ListItemIcon color='primary'>
                  <PersonAdd color='primary' />
                </ListItemIcon>
                <ListItemText color='primary' primary='Create Client Folder' />
              </ListItemButton> */}
              {/* <Divider variant='inset' /> */}
            </>
          )}

          {manageInvestor ? (
            <>
              <Grid item xs={12}>
                {showSearch ? (
                  <Grid container alignItems={"end"} justifyContent={"end"}>
                    <Grid item xs>
                      <FormControl fullWidth>
                        <InputLabel htmlFor="search-text">Search</InputLabel>
                        <Input
                          autoFocus={true}
                          id="search-text"
                          type="text"
                          value={searchText}
                          onChange={(e) => setSearchText(e.target.value)}
                          startAdornment={<Search />}
                          endAdornment={
                            loadingClientFolders ? (
                              <CircularProgress />
                            ) : (
                              searchText && (
                                <IconButton
                                  onClick={handleClearSearch}
                                  edge="end"
                                >
                                  <CloseIcon />
                                </IconButton>
                              )
                            )
                          }
                        />
                      </FormControl>
                    </Grid>
                    <Grid item>
                      <Button
                        variant="text"
                        onClick={() => {
                          setShowSearch(false);
                          handleClearSearch();
                        }}
                      >
                        Cancel
                      </Button>
                    </Grid>
                  </Grid>
                ) : (
                  <Grid
                    container
                    justifyContent={"space-between"}
                    marginTop={"5px"}
                  >
                    <Grid>
                      <Button
                        onClick={() => setManageInvestor(false)}
                        style={{ color: "white" }}
                        variant="contained"
                        startIcon={<Backspace />}
                      >
                        Back
                      </Button>
                    </Grid>
                    <Grid item xs="auto">
                      <Button
                        onClick={() => setShowSearch(true)}
                        variant="text"
                        color="primary"
                        startIcon={<Search />}
                      >
                        Search
                      </Button>
                    </Grid>
                    <Grid item>
                      <Button
                        onClick={() => setOpenCreateFolderDialog(true)}
                        style={{ color: "white" }}
                        variant="contained"
                        startIcon={<PersonAdd />}
                      >
                        Add Investor
                      </Button>
                    </Grid>
                  </Grid>
                )}
              </Grid>

              <Paper variant="outlined" style={{ marginTop: 16 }}>
                {folders.length == 0 ? (
                  <Grid
                    container
                    item
                    marginTop={8}
                    marginBottom={8}
                    justifyContent={"center"}
                  >
                    <Typography style={{ color: "grey" }}>
                      Nothing here yet
                    </Typography>
                  </Grid>
                ) : (
                  <List>
                    {folders.map((folder, index) => (
                      <>
                        <ListItem
                          disablePadding
                          disabled={
                            showingOptions &&
                            !(
                              showingOptions?.id == folder.id &&
                              showingOptions?.name == folder.name
                            )
                          }
                          selected={
                            showingOptions &&
                            showingOptions?.id == folder.id &&
                            showingOptions?.name == folder.name
                          }
                          key={folder.id}
                          // onClick={(e) => {
                          //   if (showingOptions) return;
                          //   if (
                          //     e.target.tagName.toLowerCase() == "p" ||
                          //     e.target.tagName.toLowerCase() == "span" ||
                          //     e.target.tagName.toLowerCase() == "div"
                          //   )
                          //     setCurrentFolder(folder.id, folder.name);
                          // }}
                        >
                          <ListItemAvatar>
                            <Avatar
                              style={{ backgroundColor: generateRandomColor() }}
                            >
                              {folder.name[0].toUpperCase()}
                            </Avatar>
                          </ListItemAvatar>
                          {/* <ListItemIcon>
                  <Folder />
                </ListItemIcon> */}
                          <ListItemText
                            primary={folder.name}
                            secondary={
                              <React.Fragment>
                                <Typography
                                  sx={{ display: "inline" }}
                                  component="span"
                                  variant="body2"
                                  color="text.primary"
                                >
                                  {folder?.Client?.email}
                                </Typography>
                                {` - ${moment(folder.created_at).format(
                                  "YYYY-MM-DD"
                                )}`}
                              </React.Fragment>
                            }
                          />
                          {user?.role == "A" && (
                            <ListItemSecondaryAction>
                              <ActionMenuButton
                                itemId={folder.id}
                                onOpen={() => {
                                  setShowingOptions(folder);
                                }}
                                handleEdit={(newName, newEmail, newPhone) => {
                                  rename({
                                    id: folder.id,
                                    type: "folders",
                                    newName,
                                    newEmail,
                                    newPhone,
                                  });
                                }}
                                handleDelete={() =>
                                  deleteItem({
                                    id: folder.id,
                                    email: folder?.Client?.email,
                                    type: "folders",
                                  })
                                }
                                handleMove={(destinationId) =>
                                  moveItem({
                                    id: folder.id,
                                    type: "folders",
                                    destinationId,
                                  })
                                }
                                onClose={() => {
                                  setShowingOptions(false);
                                }}
                                fileName={folder.name}
                                emailAccount={folder?.Client?.email}
                                phoneNum={folder?.Client?.phone}
                              />
                            </ListItemSecondaryAction>
                          )}
                        </ListItem>

                        {index + 1 < folders.length && (
                          <Divider variant="inset" light />
                        )}
                      </>
                    ))}
                  </List>
                )}
              </Paper>
            </>
          ) : (
            <>
              {user?.role === "A" && (
                <Paper variant="outlined" style={{ marginTop: 16 }}>
                  {/* Create Folder */}
                  {user?.role === "A" && (
                    <>
                      <ListItemButton
                        color="primary"
                        button
                        onClick={() => {
                          setOpenCreateFolderDialog(true);
                          setGenericFolderId(true);
                        }}
                        style={{
                          display: "flex",
                          alignItems: "center",
                          marginTop: 32,
                        }}
                      >
                        <ListItemIcon color="primary">
                          <CreateNewFolderIcon color="primary" />
                        </ListItemIcon>
                        <ListItemText color="primary" primary="Create Folder" />
                      </ListItemButton>
                      <Divider variant="inset" light />
                    </>
                  )}
                  {genericFolderData.length == 0 ? (
                    <Grid
                      container
                      item
                      marginTop={8}
                      marginBottom={8}
                      justifyContent={"center"}
                    >
                      <Typography style={{ color: "grey" }}>
                        Nothing here yet
                      </Typography>
                    </Grid>
                  ) : (
                    <List>
                      {genericFolderData?.map &&
                        genericFolderData?.map((file, index) => (
                          <>
                            <ListItemButton
                              disableRipple={showingOptions != null}
                              disabled={
                                showingOptions &&
                                !(
                                  showingOptions?.id == file.id &&
                                  showingOptions?.name == file.name
                                )
                              }
                              selected={
                                showingOptions &&
                                showingOptions?.id == file.id &&
                                showingOptions?.name == file.name
                              }
                              key={file.id + "_folder"}
                              onClick={(e) => {
                                e.preventDefault();
                                e.stopPropagation();
                                if (showingOptions) return;
                                // Prevent navigation only if clicking on the action menu button (three dots)
                                // Check if click is on the IconButton (MoreVert menu) or its parent ListItemSecondaryAction
                                if (
                                  e.target.closest(
                                    ".MuiListItemSecondaryAction-root"
                                  ) ||
                                  e.target.closest(
                                    'button[aria-label*="more"]'
                                  ) ||
                                  e.target.closest('button[aria-label*="More"]')
                                ) {
                                  return;
                                }
                                // Allow navigation on any other click
                                setCurrentFolder(file.id, file.name);
                              }}
                            >
                              <ListItemIcon>
                                <Folder />
                              </ListItemIcon>
                              <ListItemText
                                primary={file.name}
                                secondary={moment(file.created_at).format(
                                  "YYYY-MM-DD"
                                )}
                              />
                              {(!showingOptions ||
                                (showingOptions?.id == file.id &&
                                  showingOptions?.name == file.name)) &&
                                user?.role == "A" && (
                                  <ListItemSecondaryAction>
                                    <ActionMenuButton
                                      itemId={file.id}
                                      onOpen={() => {
                                        setShowingOptions(file);
                                      }}
                                      handleEdit={(newName) => {
                                        rename({
                                          id: file.id,
                                          type: "folders",
                                          newName,
                                          generic: "true",
                                        });
                                      }}
                                      handleDelete={() =>
                                        deleteItem({
                                          id: file.id,
                                          type: "folders",
                                          generic: "true",
                                        })
                                      }
                                      handleMove={(destinationId) =>
                                        moveItem({
                                          id: file.id,
                                          type: "folders",
                                          destinationId,
                                          generic: "true",
                                        })
                                      }
                                      onClose={() => {
                                        setShowingOptions(false);
                                      }}
                                      fileName={file.name}
                                      assignUserLoading={assignUserLoading}
                                      genericId={(folderId, userId) =>
                                        handleAssignUser({
                                          folder_id: folderId,
                                          user_id: userId,
                                        })
                                      }
                                      folder_id={file?.id}
                                    />
                                  </ListItemSecondaryAction>
                                )}
                            </ListItemButton>

                            {index + 1 < genericFolderData.length && (
                              <Divider variant="inset" light />
                            )}
                          </>
                        ))}
                    </List>
                  )}
                </Paper>
              )}

              {user?.role !== "A" && (
                <Paper variant="outlined" style={{ marginTop: 16 }}>
                  {!genericFolderData?.length ? (
                    <Grid
                      container
                      item
                      marginTop={8}
                      marginBottom={8}
                      justifyContent={"center"}
                    >
                      <Typography style={{ color: "grey" }}>
                        Nothing here yet
                      </Typography>
                    </Grid>
                  ) : (
                    <List>
                      {genericFolderData
                        .filter(
                          (folder, index, self) =>
                            index === self.findIndex((f) => f.id === folder.id)
                        )
                        .map((folder, index) => (
                          <React.Fragment key={folder.id}>
                            <ListItemButton
                              onClick={() =>
                                setCurrentFolder(folder.id, folder.name)
                              }
                            >
                              <ListItemIcon>
                                <Folder />
                              </ListItemIcon>
                              <ListItemText
                                primary={folder.name}
                                secondary={moment(folder.created_at).format(
                                  "YYYY-MM-DD"
                                )}
                              />
                            </ListItemButton>
                            <Divider variant="inset" light />
                          </React.Fragment>
                        ))}
                    </List>
                  )}
                </Paper>
              )}
            </>
          )}
        </>
      ) : (
        <>
          <Box
            display="flex"
            alignItems="center"
            justifyContent="space-between"
            className="button-container"
            sx={{ mb: 2 }}
          >
            <Box display="flex" alignItems="center">
              {(breadCrumbs?.length >= 1 || user?.role == "A") && (
                <Button
                  startIcon={<ArrowBackIcon />}
                  edge="start"
                  color="primary"
                  variant="contained"
                  style={{ padding: "2px 8px", marginRight: 8, color: "white" }}
                  onClick={() => {
                    goBack();
                  }}
                >
                  Back
                </Button>
              )}
            </Box>

            <Box display="flex" alignItems="center" gap={2}>
              <Button
                startIcon={<DescriptionIcon />}
                style={{ color: "white" }}
                variant="contained"
                color="primary"
                onClick={handleAddFileDialogOpen}
                className="file_btn"
              >
                Add file and folder
              </Button>
              {/* Pending Reviews button - Show for ALL users */}
              <Badge badgeContent={pendingCount} color="error">
                <Button
                  onClick={() => navigate("/pending-reviews")}
                  variant="outlined"
                  color="primary"
                  startIcon={<PendingActions />}
                >
                  Pending Reviews
                </Button>
              </Badge>
            </Box>
          </Box>
          <Box
            style={{ marginTop: 16 }}
            display="flex"
            alignItems="center"
            justifyContent="start"
            className="button-container"
          >
            {breadCrumbs.map((crumb, index) => {
              return breadCrumbs.length > 1 &&
                index < breadCrumbs.length - 1 ? (
                <>
                  <Typography
                    style={{ color: "grey", fontSize: 12 }}
                    variant="h6"
                  >
                    {crumb.name}
                  </Typography>
                  <ArrowForwardIcon
                    style={{ marginLeft: 4, marginRight: 4, fontSize: 12 }}
                  />
                </>
              ) : (
                <Typography
                  style={{
                    fontSize: 13,
                    borderBottom: "1.5px solid rgb(76 175 80)",

                    //intend border
                  }}
                  variant="h6"
                >
                  {crumb.name}
                </Typography>
              );
            })}
          </Box>

          <Paper variant="outlined" style={{ marginTop: 16, marginBottom: 16 }}>
            {user?.role === "A" && (
              <>
                <ListItemButton
                  color="primary"
                  button
                  onClick={() => setOpenCreateFolderDialog(true)}
                  style={{
                    display: "flex",
                    alignItems: "center",
                    marginTop: 32,
                  }}
                >
                  <ListItemIcon color="primary">
                    <CreateNewFolderIcon color="primary" />
                  </ListItemIcon>
                  <ListItemText color="primary" primary="Create Folder" />
                </ListItemButton>
                <Divider variant="inset" light />
              </>
            )}
            {files.length === 0 ? (
              <Grid
                container
                item
                marginTop={8}
                marginBottom={8}
                justifyContent={"center"}
              >
                <Typography style={{ color: "grey" }}>
                  Nothing here yet
                </Typography>
              </Grid>
            ) : (
              <>
                {user?.role === "A" ? (
                  <>
                    {user?.role === "A" ? (
                      /* Admin view - show files in flat list */
                      <List style={{ paddingTop: "0" }}>
                        {files?.map &&
                          files?.map((file, index) => (
                            <>
                              {file.filePath ? (
                                <ListItem
                                  key={file.id}
                                  disabled={
                                    showingOptions &&
                                    !(
                                      showingOptions?.id == file.id &&
                                      showingOptions?.name == file.name
                                    )
                                  }
                                  selected={
                                    showingOptions &&
                                    showingOptions?.id == file.id &&
                                    showingOptions?.name == file.name
                                  }
                                >
                                  <ListItemIcon>
                                    <DescriptionIcon />
                                  </ListItemIcon>
                                  <ListItemText
                                    primary={
                                      <Box
                                        sx={{
                                          display: "flex",
                                          alignItems: "center",
                                          gap: 1,
                                        }}
                                      >
                                        <Button
                                          sx={{ padding: 0 }}
                                          disabled={
                                            file.id == downloadingFileID
                                          }
                                          onClick={() => {
                                            // Admins can always download/view files, even if under review
                                            if (
                                              user?.role !== "A" &&
                                              file.status &&
                                              file.status !== "approved"
                                            ) {
                                              alert(
                                                "This file is under review and cannot be opened yet."
                                              );
                                              return;
                                            }
                                            downloadFile(
                                              file.id,
                                              file.name,
                                              file.filePath
                                            );
                                          }}
                                          variant="text"
                                        >
                                          {file.name}
                                        </Button>
                                        {file.status === "in_review" && (
                                          <Chip
                                            size="small"
                                            label="In Review"
                                            color="warning"
                                          />
                                        )}
                                        {file.status === "rejected" && (
                                          <Chip
                                            size="small"
                                            label="Rejected"
                                            color="error"
                                          />
                                        )}
                                      </Box>
                                    }
                                    secondary={
                                      <Box component="span">
                                        <Box
                                          component="span"
                                          sx={{
                                            display: "block",
                                            fontSize: "0.875rem",
                                            color: "text.secondary",
                                          }}
                                        >
                                          {moment(file.uploaded_at).format(
                                            "YYYY-MM-DD"
                                          )}
                                        </Box>
                                        {file.status === "in_review" &&
                                          user?.role === "A" &&
                                          file.uploadedBy && (
                                            <Box
                                              component="span"
                                              sx={{
                                                display: "block",
                                                mt: 0.5,
                                                fontSize: "0.75rem",
                                                color: "text.secondary",
                                              }}
                                            >
                                              Uploaded by:{" "}
                                              {file.Uploader?.name ||
                                                `User ID: ${file.uploadedBy}`}
                                            </Box>
                                          )}
                                        {user?.role !== "A" &&
                                          file.status &&
                                          file.status !== "approved" && (
                                            <Box
                                              component="span"
                                              sx={{
                                                display: "block",
                                                fontSize: "0.75rem",
                                                color: "warning.main",
                                              }}
                                            >
                                              This file is under review by the
                                              admin.
                                            </Box>
                                          )}
                                      </Box>
                                    }
                                  />

                                  <ListItemSecondaryAction
                                    style={{ display: "flex" }}
                                  >
                                    {file.id == downloadingFileID ? (
                                      <CircularProgress />
                                    ) : showingOptions ? (
                                      <></>
                                    ) : (
                                      <IconButton
                                        color="primary"
                                        variant="outlined"
                                        disabled={file.id == downloadingFileID}
                                        onClick={() => {
                                          // Admins can always download files, even if under review
                                          if (
                                            user?.role !== "A" &&
                                            file.status &&
                                            file.status !== "approved"
                                          ) {
                                            alert(
                                              "This file is under review and cannot be downloaded yet."
                                            );
                                            return;
                                          }
                                          downloadFile(
                                            file.id,
                                            file.name,
                                            file.filePath
                                          );
                                        }}
                                      >
                                        <Download />
                                      </IconButton>
                                    )}
                                    {(!showingOptions ||
                                      (showingOptions?.id == file.id &&
                                        showingOptions?.name == file.name)) &&
                                      user?.role == "A" && (
                                        <ActionMenuButton
                                          itemId={file.id}
                                          onOpen={() => {
                                            setShowingOptions(file);
                                          }}
                                          handleEdit={(
                                            newName,
                                            newEmail,
                                            newPhone
                                          ) => {
                                            rename({
                                              id: file.id,
                                              type: "files",
                                              oldName: file.name,
                                              newName,
                                              newEmail,
                                              newPhone,
                                            });
                                          }}
                                          handleDelete={() =>
                                            deleteItem({
                                              id: file.id,
                                              type: "files",
                                            })
                                          }
                                          handleMove={(destinationId) =>
                                            moveItem({
                                              id: file.id,
                                              type: "files",
                                              destinationId,
                                            })
                                          }
                                          onClose={() => {
                                            setShowingOptions(false);
                                          }}
                                          fileName={file.name.substring(
                                            0,
                                            file.name.lastIndexOf(".")
                                          )}
                                        />
                                      )}
                                  </ListItemSecondaryAction>
                                </ListItem>
                              ) : (
                                <ListItemButton
                                  disableRipple={showingOptions != null}
                                  disabled={
                                    showingOptions &&
                                    !(
                                      showingOptions?.id == file.id &&
                                      showingOptions?.name == file.name
                                    )
                                  }
                                  selected={
                                    showingOptions &&
                                    showingOptions?.id == file.id &&
                                    showingOptions?.name == file.name
                                  }
                                  key={file.id + "_folder"}
                                  onClick={(e) => {
                                    e.preventDefault();
                                    e.stopPropagation();
                                    if (showingOptions) return;
                                    // Prevent navigation only if clicking on the action menu button (three dots)
                                    // Check if click is on the IconButton (MoreVert menu) or its parent ListItemSecondaryAction
                                    if (
                                      e.target.closest(
                                        ".MuiListItemSecondaryAction-root"
                                      ) ||
                                      e.target.closest(
                                        'button[aria-label*="more"]'
                                      ) ||
                                      e.target.closest(
                                        'button[aria-label*="More"]'
                                      )
                                    ) {
                                      return;
                                    }
                                    // Allow navigation on any other click
                                    setCurrentFolder(file.id, file.name);
                                  }}
                                >
                                  <ListItemIcon>
                                    <Folder />
                                  </ListItemIcon>
                                  <ListItemText
                                    primary={file.name}
                                    secondary={moment(file.created_at).format(
                                      "YYYY-MM-DD"
                                    )}
                                  />
                                  {(!showingOptions ||
                                    (showingOptions?.id == file.id &&
                                      showingOptions?.name == file.name)) &&
                                    user?.role == "A" && (
                                      <ListItemSecondaryAction>
                                        <ActionMenuButton
                                          itemId={file.id}
                                          onOpen={() => {
                                            setShowingOptions(file);
                                          }}
                                          handleEdit={(newName) => {
                                            rename({
                                              id: file.id,
                                              type: "folders",
                                              newName,
                                            });
                                          }}
                                          handleDelete={() =>
                                            deleteItem({
                                              id: file.id,
                                              type: "folders",
                                            })
                                          }
                                          handleMove={(destinationId) =>
                                            moveItem({
                                              id: file.id,
                                              type: "folders",
                                              destinationId,
                                            })
                                          }
                                          onClose={() => {
                                            setShowingOptions(false);
                                          }}
                                          fileName={file.name}
                                        />
                                      </ListItemSecondaryAction>
                                    )}
                                </ListItemButton>
                              )}
                              {index + 1 < files.length && (
                                <Divider variant="inset" light />
                              )}
                            </>
                          ))}
                      </List>
                    ) : (
                      /* Non-admin view - show files in tree view */
                      <Box sx={{ mt: 2 }}>
                        <FileTree
                          files={files.filter((f) => f.filePath)}
                          onDownload={(fileId, name, filePath) => {
                            const file = files.find((f) => f.id === fileId);
                            if (
                              file &&
                              file.status &&
                              file.status !== "approved"
                            ) {
                              alert(
                                "This file is under review and cannot be downloaded yet."
                              );
                              return;
                            }
                            downloadFile(fileId, name, filePath);
                          }}
                          showActions={false}
                          downloadingFileID={downloadingFileID}
                          isAdmin={false}
                          currentPath={currentPath}
                        />
                      </Box>
                    )}
                  </>
                ) : (
                  <>
                    {/* Show folders in regular list */}
                    {files.filter((f) => !f.filePath).length > 0 && (
                      <List>
                        {files
                          .filter((f) => !f.filePath)
                          .map((file, index) => (
                            <React.Fragment key={file.id}>
                              <ListItemButton
                                disableRipple={showingOptions != null}
                                disabled={
                                  showingOptions &&
                                  !(
                                    showingOptions?.id == file.id &&
                                    showingOptions?.name == file.name
                                  )
                                }
                                selected={
                                  showingOptions &&
                                  showingOptions?.id == file.id &&
                                  showingOptions?.name == file.name
                                }
                                onClick={(e) => {
                                  e.preventDefault();
                                  e.stopPropagation();
                                  if (showingOptions) return;
                                  // Prevent navigation only if clicking on the action menu button (three dots)
                                  // Check if click is on the IconButton (MoreVert menu) or its parent ListItemSecondaryAction
                                  if (
                                    e.target.closest(
                                      ".MuiListItemSecondaryAction-root"
                                    ) ||
                                    e.target.closest(
                                      'button[aria-label*="more"]'
                                    ) ||
                                    e.target.closest(
                                      'button[aria-label*="More"]'
                                    )
                                  ) {
                                    return;
                                  }
                                  // Allow navigation on any other click
                                  setCurrentFolder(file.id, file.name);
                                }}
                              >
                                <ListItemIcon>
                                  <Folder />
                                </ListItemIcon>
                                <ListItemText
                                  primary={file.name}
                                  secondary={moment(file.created_at).format(
                                    "YYYY-MM-DD"
                                  )}
                                />
                                {(!showingOptions ||
                                  (showingOptions?.id == file.id &&
                                    showingOptions?.name == file.name)) &&
                                  user?.role == "A" && (
                                    <ListItemSecondaryAction>
                                      <ActionMenuButton
                                        itemId={file.id}
                                        onOpen={() => {
                                          setShowingOptions(file);
                                        }}
                                        handleEdit={(newName) => {
                                          rename({
                                            id: file.id,
                                            type: "folders",
                                            newName,
                                          });
                                        }}
                                        handleDelete={() =>
                                          deleteItem({
                                            id: file.id,
                                            type: "folders",
                                          })
                                        }
                                        handleMove={(destinationId) =>
                                          moveItem({
                                            id: file.id,
                                            type: "folders",
                                            destinationId,
                                          })
                                        }
                                        onClose={() => {
                                          setShowingOptions(false);
                                        }}
                                        fileName={file.name}
                                      />
                                    </ListItemSecondaryAction>
                                  )}
                              </ListItemButton>
                              {index + 1 <
                                files.filter((f) => !f.filePath).length && (
                                <Divider variant="inset" light />
                              )}
                            </React.Fragment>
                          ))}
                      </List>
                    )}
                    {/* Show files in tree view for non-admin users */}
                    {files.filter((f) => f.filePath).length > 0 ? (
                      <Box sx={{ mt: 2 }}>
                        <FileTree
                          files={files.filter((f) => f.filePath)}
                          currentPath={currentPath}
                          onDownload={(fileId, name, filePath) => {
                            const file = files.find((f) => f.id === fileId);
                            if (
                              file &&
                              file.status &&
                              file.status !== "approved"
                            ) {
                              alert(
                                "This file is under review and cannot be downloaded yet."
                              );
                              return;
                            }
                            downloadFile(fileId, name, filePath);
                          }}
                          showActions={false}
                          downloadingFileID={downloadingFileID}
                          isAdmin={user?.role === "A"}
                        />
                      </Box>
                    ) : files.length === 0 ? (
                      <Grid
                        container
                        item
                        marginTop={8}
                        marginBottom={8}
                        justifyContent={"center"}
                      >
                        <Typography style={{ color: "grey" }}>
                          Nothing here yet
                        </Typography>
                      </Grid>
                    ) : null}
                  </>
                )}
              </>
            )}
          </Paper>
        </>
      )}

      <Dialog
        fullWidth
        maxWidth="sm"
        open={sendEmailDialogOpen}
        onClose={handleCloseSendEmailDialog}
      >
        <DialogTitle>Send Email</DialogTitle>
        <DialogContent dividers>
          <Box display="flex" alignItems="center" mb={2}>
            <FormControlLabel
              control={
                <Checkbox
                  checked={
                    selectedEmailRecipients.length === (folders?.length || 0) &&
                    (folders?.length || 0) > 0
                  }
                  indeterminate={
                    selectedEmailRecipients.length > 0 &&
                    selectedEmailRecipients.length < (folders?.length || 0)
                  }
                  onChange={(e) => {
                    if (e.target.checked) {
                      setSelectedEmailRecipients(folders || []);
                    } else {
                      setSelectedEmailRecipients([]);
                    }
                  }}
                />
              }
              label="Select All"
            />
          </Box>

          <Autocomplete
            multiple
            options={folders || []}
            value={selectedEmailRecipients}
            disableCloseOnSelect
            getOptionLabel={(option) => option?.name || "Unnamed"}
            onChange={handleSelectedRecipientsChange}
            renderOption={(props, option, { selected }) => (
              <li {...props}>
                <Checkbox
                  icon={<CheckBoxOutlineBlank fontSize="small" />}
                  checkedIcon={<CheckBox fontSize="small" />}
                  style={{ marginRight: 8 }}
                  checked={selected}
                />
                {option.name}
              </li>
            )}
            renderInput={(params) => (
              <TextField
                {...params}
                label="Recipients"
                placeholder="Choose investors"
              />
            )}
          />

          <TextField
            fullWidth
            label="Subject"
            margin="normal"
            value={emailSubject}
            onChange={(e) => setEmailSubject(e.target.value)}
          />
          <Box sx={{ mt: 2 }}>
            <Typography variant="subtitle2" color="text.secondary" gutterBottom>
              Message
            </Typography>
            <ReactQuill
              theme="snow"
              value={emailMessage}
              onChange={setEmailMessage}
              modules={quillModules}
              formats={quillFormats}
              placeholder="Compose your email..."
              style={{
                height: 200,
                marginBottom: 40,
              }}
            />
          </Box>
          {sendEmailError && (
            <Alert severity="error" sx={{ mt: 2 }}>
              {sendEmailError}
            </Alert>
          )}
          {sendEmailSuccess && (
            <Alert severity="success" sx={{ mt: 2 }}>
              {sendEmailSuccess}
            </Alert>
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseSendEmailDialog}>Cancel</Button>
          <Button
            variant="contained"
            color="primary"
            style={{ color: "white" }}
            disabled={
              sendingEmail ||
              !emailSubject.trim() ||
              isEmailBodyEmpty ||
              (sendEmailMode === "selected" &&
                selectedEmailRecipients.length === 0)
            }
            onClick={handleSendEmail}
          >
            {sendingEmail ? "Sending..." : "Send"}
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog
        fullWidth
        maxWidth={"xs"}
        open={openAddFileDialog}
        onClose={handleAddFileDialogClose}
      >
        <DialogTitle>Add File or Folder</DialogTitle>
        <DialogContent>
          {/* {/ Drag and Drop Area /} */}
          <Box
            {...getRootProps()}
            sx={{
              border: "2px dashed #ccc",
              borderRadius: "4px",
              padding: "16px",
              textAlign: "center",
              cursor: "pointer",
              backgroundColor: isDragActive ? "#f0f8ff" : "white", // Highlight when dragging
              borderColor: isDragActive ? "#00f" : "#ccc", // Change border color when dragging
            }}
            onClick={open}
          >
            <input {...getInputProps()} />
            <Typography>
              Drag & drop files and folders here, or click to select files or
              folders.
            </Typography>
          </Box>
          {selectedFiles && selectedFiles.length > 0 && (
            <Box mt={2}>
              {selectedFiles &&
                selectedFiles.map((file) => (
                  <Typography key={file.name}>{file.name}</Typography>
                ))}
            </Box>
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={handleAddFileDialogClose}>Cancel</Button>
          <Button
            variant="contained"
            color="primary"
            onClick={onUpload}
            style={{ color: "white" }}
            disabled={selectedFiles?.length === 0 || uploading}
          >
            {uploading ? <CircularProgress size={24} /> : "Upload"}
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog
        fullWidth
        maxWidth={"xs"}
        open={openCreateFolderDialog}
        onClose={handleCreateFolderDialogClose}
      >
        <DialogTitle>
          Create{" "}
          {!currentFolderId
            ? genericFolderId
              ? "Folder"
              : "Investor"
            : "Folder"}
        </DialogTitle>
        <DialogContent>
          {/* Create Folder Dialog Content */}
          <FormControl fullWidth sx={{ marginTop: 2 }}>
            <InputLabel htmlFor="folder-name">
              {!currentFolderId
                ? genericFolderId
                  ? "Folder"
                  : "Investor"
                : "Folder"}{" "}
              Name
            </InputLabel>
            <Input
              id="folder-name"
              type="text"
              value={newFolderName}
              onChange={handleFolderNameChange}
            />
          </FormControl>
          {!currentFolderId ? (
            genericFolderId ? (
              ""
            ) : (
              <FormControl fullWidth sx={{ marginTop: 2 }}>
                <InputLabel htmlFor="folder-email">Email</InputLabel>
                <Input
                  id="folder-email"
                  type="email"
                  value={newFolderEmail}
                  onChange={handleNewFolderEmailChange}
                />
              </FormControl>
            )
          ) : (
            ""
          )}
          {!currentFolderId ? (
            genericFolderId ? (
              ""
            ) : (
              <FormControl fullWidth sx={{ marginTop: 2 }}>
                <InputLabel htmlFor="folder-phone">Phone</InputLabel>
                <Input
                  id="folder-phone"
                  value={newFolderPhone}
                  onChange={handleNewFolderPhoneChange}
                />
              </FormControl>
            )
          ) : (
            ""
          )}
          {error && <Alert severity="error">{error}</Alert>}
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCreateFolderDialogClose}>Cancel</Button>
          <Button
            variant="contained"
            color="primary"
            style={{ color: creatingFolder ? "grey" : "white" }}
            onClick={createFolder}
            disabled={
              !newFolderName ||
              creatingFolder ||
              (!newFolderEmail &&
                !newFolderPhone &&
                !currentFolderId &&
                !genericFolderId)
            }
          >
            {creatingFolder
              ? "Creating..."
              : `Create ${
                  !currentFolderId
                    ? genericFolderId
                      ? "Folder"
                      : "Investor"
                    : "Folder"
                }`}
          </Button>
        </DialogActions>
      </Dialog>
    </Container>
  );
}

export default Dashboard;
